import { supabase } from "@/integrations/supabase/client";
import { Agent } from "@/types/agent/agent";

export class ConversationRecorder {
  static async recordConversationStart(
    elAgentId: string,
    conversationId: string,
    userId: string,
    isQuickTest?: boolean,
  ): Promise<void> {
    // Fire and forget - don't block the conversation start
    (async () => {
      try {
        const conversationData: any = {
          el_agent_id: elAgentId,
          elevenlabs_id: conversationId,
          user_id: userId || undefined,
        };

        if (isQuickTest) {
          conversationData.metadata = { is_quick_test: true };
        }

        console.log("Recording conversation start:", conversationData);

        const { error } = await supabase.from("conversations").upsert([conversationData], {
          onConflict: "elevenlabs_id",
          ignoreDuplicates: false,
        });

        if (error) {
          throw new Error(`Error saving conversation: ${error}`);
        }
      } catch (error) {
        console.error("Failed to record conversation:", error);
      }
    })();
  }

  static async updateConversationDetailsWithTranscript(
    conversationId: string,
    _dbAgent: Agent,
  ): Promise<boolean> {
    try {
      console.log("Invoking edge function to re-analyze conversation:", conversationId);

      // Fetch the conversation to get its database ID
      const { data: conversation, error: fetchError } = await supabase
        .from("conversations")
        .select("id")
        .eq("elevenlabs_id", conversationId)
        .single();

      if (fetchError || !conversation) {
        console.error("Failed to fetch conversation:", fetchError);
        return false;
      }

      const { data, error } = await supabase.functions.invoke("handle-conversation", {
        body: {
          action: "analyse",
          data: {
            conversationId: conversation.id,
          },
        },
      });

      if (error) {
        console.error("Edge function invocation error:", error);
        return false;
      }

      console.log("Edge function response:", data);
      return data?.success || false;
    } catch (error) {
      console.error("Failed to update conversation details:", error);
      return false;
    }
  }
}
